import {
  FormPageAuthInputItemPasswordHashFree,
  FormPageInputItemPasswordHashText,
} from 'shared';

const convertFree = (password?: string): string | undefined => {
  if (password === '') {
    return undefined;
  }
  return password;
};

export const convertPasswordHashText = (
  value: FormPageInputItemPasswordHashText,
): string | undefined => {
  return convertFree(value.password);
};

export const convertAuthPasswordHashFree = (
  value: FormPageAuthInputItemPasswordHashFree,
): string | undefined => {
  return convertFree(value.password);
};
